import {
  useQuery,
  useMutation,
  useQueryClient,
  keepPreviousData,
} from '@tanstack/react-query';
import api from './api';

// Créer une nouvelle produits
export const useCreateProduit = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data) => api.post('/produits/addProduit', data),
    onSuccess: () => queryClient.invalidateQueries(['produits']),
  });
};

// Mettre à jour une produits
export const useUpdateProduit = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, data }) =>
      api.put(`/produits/updateProduit/${id}`, data),
    onSuccess: () => queryClient.invalidateQueries(['produits']),
  });
};

// Lire toutes les produits
export const useAllProduit = () =>
  useQuery({
    queryKey: ['produits'],
    queryFn: () => api.get('/produits/getAllProduits').then((res) => res.data),
    placeholderData: keepPreviousData,
  });

// Lire toutes les produits
export const usePagignationProduit = (
  page = 1,
  limit = 35,
  search = '',
  category = null,
  inStock = null
) =>
  useQuery({
    queryKey: ['produits', page, limit, search, category, inStock],
    queryFn: () =>
      api
        .get('/produits/getPagignationProduits', {
          params: {
            page,
            limit,
            search: search || undefined,
            category: category || undefined,
            inStock: inStock ? '1' : undefined,
          },
        })
        .then((res) => res.data),
    placeholderData: keepPreviousData,
    staleTime: 1000 * 30,
  });

// Produit dont le Stock est terminé
export const useAllProduitWithStockInferieure = () =>
  useQuery({
    queryKey: ['produits'],
    queryFn: () =>
      api.get('/produits/getAllProduitWithStockFinish').then((res) => res.data),
  });
export const usePagignationProduitWithStockInferieure = (
  page = 1,
  limit = 35,
  search = '',
  category = null
) =>
  useQuery({
    /**
     * AJOUT (cache pro):
     * On inclut search/category dans la queryKey pour que React Query cache
     * correctement chaque combinaison (page + recherche + filtre).
     */
    queryKey: ['produits', 'stock-faible', page, limit, search, category],
    queryFn: () =>
      api
        .get('/produits/getPagignationProduitWithStockFinish', {
          /**
           * AJOUT (recherche serveur):
           * On passe search/category au backend pour filtrer AVANT pagination.
           * Ça évite de filtrer seulement la page courante côté frontend.
           */
          params: {
            page,
            limit,
            search: search || undefined,
            category: category || undefined,
          },
        })
        .then((res) => res.data),
    placeholderData: keepPreviousData,
    staleTime: 1000 * 30,
  });

// Obtenir un Produit
export const useOneProduit = (id) =>
  useQuery({
    queryKey: ['getProduit', id],
    queryFn: () =>
      api.get(`/produits/getOneProduit/${id}`).then((res) => res.data),
    enabled: Boolean(id),
    staleTime: 1000 * 60 * 1, //chaque 5 minutes rafraichir les données
  });

// Affficher le produit lors de l'approvisonnement
export const useOneProduitWhenApprovisionne = (id) =>
  useQuery({
    queryKey: ['getProduit', id],
    queryFn: () => api.get(`/approvisonnement/${id}`).then((res) => res.data),
    enabled: Boolean(id),
    staleTime: 1000 * 60 * 1, //chaque 1 minutes rafraichir les données
  });

// Supprimer une produits
export const useDeleteProduit = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id) => api.delete(`/produits/deleteProduit/${id}`),
    onSuccess: () => queryClient.invalidateQueries(['produits']),
  });
};
